import {
    Button,
    Icon,
    useDisclosure,
    Text,
    Flex,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader, ModalCloseButton, ModalBody,
} from "@chakra-ui/react";
import { useRef } from "react";
import {
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
} from '@chakra-ui/react'
import { TbMenu2 } from "react-icons/tb";
import { MdClose } from "react-icons/md";
import MenuLink from "../MenuLink/MenuLink";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider/AuthProvider";
import { useTranslation } from "react-i18next";

const MobileMenu = ({ routes }) => {
    const { t } = useTranslation("default");
    const { user, logout } = useAuth();
    const buttonRef = useRef(null);
    const navigate = useNavigate();
    const { isOpen: isDrawerOpen, onOpen: onDrawerOpen, onClose: onDrawerClose } = useDisclosure();

    const handleNavigate = (route) => {
        navigate(route);
        onDrawerClose();
    }

    const handleLogin = () => {
        navigate('/login');
        onDrawerClose();
    }

    const handleLogout = () => {
        logout();
        navigate('/');
        onDrawerClose();
    }

    return (
        <>
            <Flex display={{ base: 'flex', lg: 'none' }}>
                <Button ref={buttonRef} bg={'transparent'} onClick={onDrawerOpen} p={0}
                    _hover={{ textDecoration: "none", bg: 'transparent' }}>
                    <Icon as={TbMenu2} color={'white'} boxSize={6} />
                </Button>
                <Drawer
                    isOpen={isDrawerOpen}
                    size={'xs'}
                    placement='left'
                    onClose={onDrawerClose}
                    finalFocusRef={buttonRef}
                    closeOnOverlayClick
                >
                    <DrawerOverlay />
                    <DrawerContent bg={'primary'} color={'white'} px={0} w={'65vw !important'}>
                        <DrawerHeader display="flex" gap="8px" fontSize={16} fontWeight={400} alignItems={'center'}>
                            <Icon as={MdClose} color={'white'} boxSize={6} onClick={onDrawerClose} />
                            {t('menu.menu')}
                        </DrawerHeader>

                        <DrawerBody display={'flex'} flexDirection={'column'} px={0}>
                            {routes?.filter(item => user || item.type === 'public').map((item, index) => {
                                return <MenuLink key={index}
                                    onClick={() => handleNavigate(item.route)}
                                    address={item.route || '#'}
                                    _hover={{ textDecoration: "none", bg: 'rgba(255, 255, 255, 0.05)' }}
                                    showActive
                                    fontSize={14}
                                    py={3} px={6}>
                                    {item.label}
                                </MenuLink>
                            })}
                        </DrawerBody>
                        <DrawerFooter display={'flex'} flexDirection={'column'} alignItems={'flex-start'}>
                            {user ? (
                                <>
                                    <Text opacity={0.6} fontSize={14}>{t('menu.logged_user')}:</Text>
                                    <Text fontSize={14} textOverflow="ellipsis" mb={4} fontFamily={"'Ubuntu', sans-serif"}>
                                        {user?.email}
                                    </Text>
                                    <Button color="white" variant="solid" width="100%" fontSize={14} fontWeight={500} bg={'brand.500'} borderRadius={32} onClick={handleLogout}>
                                        {t('menu.logout')}
                                    </Button>
                                </>
                            ) : (
                                <Button color="white" variant="solid" width="100%" fontSize={14} fontWeight={500}
                                    bg={'brand.500'} borderRadius={32} onClick={handleLogin}>
                                    {t('menu.login')}
                                </Button>
                            )}
                        </DrawerFooter>
                    </DrawerContent>
                </Drawer>
            </Flex>
        </>
    )
}

export default MobileMenu;
